import cn from 'classnames'
import {Formik} from 'formik'
import React, {useState, useMemo, useContext} from 'react'
import {Button, Col, Form, FormGroup, Row} from 'reactstrap'
import TextInput from 'ui/forms/text_input'
import Textarea from 'ui/forms/textarea'
import ApiFetcher from 'lib/api_fetcher'
import AppContext from 'utils/app_context'
import { useTranslation } from 'react-i18next'

const ContactForm = (props) => {
  const {client_provider} = useContext(AppContext)

  const {
    email = (client_provider && client_provider.support_email) || 'soporte@ociobusiness.es',
    phone = (client_provider && client_provider.support_telephone) || '(+34) 628 53 13 20',
    phone_label = (client_provider && client_provider.support_telephone_label) || '+34628531320',
    showEmail = true,
    showPhone = true
  } = props
  const [sent, setSent] = useState(false)
  const { t, i18n } = useTranslation()

  const onSubmit = (values, { props, setSubmitting, setErrors }) => {
    new ApiFetcher({
      key: 'contact',
      endpoint: '/contact',
      method: 'POST',
      body: JSON.stringify(values)
    }).call()
      .then((res) => {
        if (res.success == true) {
          setSent(true)
        } else {
          setErrors(res.errors)
        }
      })
      .finally(() => setSubmitting(false))
  }

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={useMemo(() => ({
        name: '',
        email: '',
        subject: '',
        message: ''
      }), [])
      }
    >
      {({
        submitForm,
        isValid,
        isSubmitting
      }) => (
        <React.Fragment>
          {sent ? (
            <h4 className="text-center"><i className="fa fa-check text-success me-2"/>{i18n.t('header_contact_form.email_sent_message')}</h4>
          ) : (
            <Form>
              <p>{i18n.t('header_contact_form.instructions')}:</p>
              <FormGroup>
                <Row>
                  <Col xs="12" md="6">
                    <TextInput label={i18n.t('header_contact_form.name')} name="name" required/>
                  </Col>
                  <Col xs="12" md="6">
                    <TextInput label={i18n.t('header_contact_form.email')} name="email" type="email" required/>
                  </Col>
                </Row>
              </FormGroup>
              <FormGroup>
                <Row>
                  <Col>
                    <TextInput label={i18n.t('header_contact_form.subject')} name="subject" required/>
                  </Col>
                </Row>
              </FormGroup>
              <FormGroup>
                <Row>
                  <Col>
                    <Textarea label={i18n.t('header_contact_form.message')} name="message" required/>
                  </Col>
                </Row>
              </FormGroup>

              <Button
                size={'lg'}
                color='primary'
                className={cn([
                  'text-white w-100',
                  isSubmitting || !isValid ? 'disabled' : ''
                ])}
                onClick={() => submitForm()}
              >
                {isSubmitting ? (
                  i18n.t('header_contact_form.sending')
                ) : (
                  i18n.t('header_contact_form.sent')
                )}
              </Button>
              <hr/>
              {(showPhone || showEmail) &&
                <React.Fragment>
                  <p>{i18n.t('header_contact_form.other_channels_to_contact_us')}:</p>
                  {showPhone &&
                    <p><strong><i className="fa fa-phone me-2" aria-hidden="true"></i>{i18n.t('header_contact_form.phone')}: </strong><a href={`tel:${phone}`}>{phone_label}</a></p>
                  }
                  {showEmail &&
                    <p><strong><i className="fa fa-envelope me-2" aria-hidden="true"></i>{i18n.t('header_contact_form.email')}: </strong><a href={`mailto:${email}`}>{email}</a></p>
                  }
                </React.Fragment>
              }

            </Form>
          )}
        </React.Fragment>

      )}
    </Formik>
  )

}

export default ContactForm
